export default `
  mutation reportBrowserErrors($errors: AWSJSON!) {
    reportBrowserErrors(errors: $errors)
  }
`
